export const IDENTITY_LOGOUT_REQUEST = 'IDENTITY/LOGOUT_REQUEST'
export const IDENTITY_LOGOUT_SUCCESS = 'IDENTITY/LOGOUT_SUCCESS'

export const IDENTITY_FORCE_LOGOUT_REQUEST = 'IDENTITY/FORCE_LOGOUT_REQUEST'
export const IDENTITY_FORCE_LOGOUT_SUCCESS = 'IDENTITY/FORCE_LOGOUT_SUCCESS'

export const IDENTITY_UPLOAD_AVATAR_REQUEST = 'IDENTITY/UPLOAD_AVATAR_REQUEST'
